import React, { useState, useEffect, useRef, useCallback } from 'react';
import useIdleTimer from '../../hooks/useIdleTimer';
import './IdleTimerModal.css';

const C = { card:'#0d1117', border:'#1e293b', text:'#f1f5f9', muted:'#64748b', accent:'#f59e0b' };

const IdleTimerWrapper = ({
  onLogout,
  timeout = 2700000,    // 45 minutos por defecto
  warningTime = 30000   // 30 segundos de advertencia por defecto
}) => {
  const [showModal, setShowModal] = useState(false);
  const [countdown, setCountdown] = useState(warningTime / 1000);
  const [warningActive, setWarningActive] = useState(false);
  const hasCalledLogout = useRef(false);

  const handleIdle = useCallback(() => {
    if (hasCalledLogout.current) {
      console.log('⚠️ handleIdle ya fue ejecutado, ignorando');
      return;
    }
    console.log('🚨 Tiempo agotado - CERRANDO SESIÓN');
    hasCalledLogout.current = true;
    setShowModal(false);
    setWarningActive(false);
    onLogout();
  }, [onLogout]);

  const handleWarning = useCallback(() => {
    console.log('⚠️ Advertencia de inactividad - MOSTRANDO MODAL');
    hasCalledLogout.current = false;
    setShowModal(true);
    setWarningActive(true);
    setCountdown(warningTime / 1000);
  }, [warningTime]);

  const { resetTimer } = useIdleTimer({
    timeout,
    onIdle: handleIdle,
    warningTime,
    onWarning: handleWarning
  });

  // Countdown
  useEffect(() => {
    if (!warningActive || !showModal) {
      return;
    }

    console.log('⏱️ Countdown iniciado:', warningTime / 1000, 'segundos');

    const interval = setInterval(() => {
      setCountdown(prev => {
        const newValue = prev - 1;

        if (newValue <= 0) {
          console.log('⏱️ Countdown terminado - cerrando sesión');
          clearInterval(interval);
          handleIdle();
          return 0;
        }

        return newValue;
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [warningActive, showModal, warningTime, handleIdle]);

  const handleStayConnected = () => {
    console.log('✅ Usuario decidió continuar conectado');
    setShowModal(false);
    setWarningActive(false);
    setCountdown(warningTime / 1000);
    hasCalledLogout.current = false;
    resetTimer();
  };

  if (!showModal) return null;

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', zIndex:1050, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
      <div style={{ background:C.card, border:'1px solid '+C.border, borderRadius:12, width:'100%', maxWidth:420, overflow:'hidden' }}>
        <div style={{ padding:'20px 24px', textAlign:'center' }}>
          <div style={{ fontSize:40, marginBottom:12 }}>⚠️</div>
          <h2 style={{ color:C.text, margin:'0 0 12px', fontSize:'1.2rem' }}>Sesión por expirar</h2>
          <p style={{ color:C.muted, margin:'0 0 24px', fontSize:'0.95rem' }}>
            Tu sesión se cerrará por inactividad en <strong style={{ color:C.text }}>{countdown}</strong> segundos
          </p>
          <div style={{ display:'flex', gap:10, justifyContent:'center' }}>
            <button
              onClick={handleStayConnected}
              style={{ background:C.accent, color:'#000', border:'none', borderRadius:6, padding:'8px 20px', fontWeight:600, cursor:'pointer', fontFamily:'inherit' }}
            >
              Continuar conectado
            </button>
            <button
              onClick={onLogout}
              style={{ background:'transparent', color:'#ef4444', border:'1px solid rgba(239,68,68,0.4)', borderRadius:6, padding:'8px 20px', cursor:'pointer', fontFamily:'inherit' }}
            >
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IdleTimerWrapper;
